import * as Immutable from 'immutable';
import * as ActionTypes from '../constants/ActionTypes';

const defaultCoords = [0, 0];

const customerState = Immutable.fromJS({
  account: {
    new: false,
    activeVendorId: null,
    email: '',
    name: '',
    zip: '',
    vendor_id: 0
  },
  loaded: false,
  loading: {
    vendors: false,
    location: false,
    logo: false,
    photos: false,
    profilePic: false
  },
  errors: {
    location: false
  },
  location: {
    coords: {
      latitide: 44.4759,
      longitude: 73.2121
    },
    place_name: ''
  },
  toggle: {
    menu: false
  }
});

function setState(state, newState) {
  return state.merge(newState);
}

export function customer(state = customerState, action) {
  switch(action.type) {
    case ActionTypes.CUSTOMER_LOADED:
      return setState(state, state.set('loaded', action.payload));

    case ActionTypes.CUSTOMER_RESOURCE_LOADING:
      return setState(state, state.setIn(['loading', action.resource], action.value));

    case ActionTypes.GET_CUSTOMER_DETAILS:
      return setState(state, state.withMutations(map => map
        .setIn(['account', 'email'], action.payload.attributes.email)
        .setIn(['account', 'name'], action.payload.attributes.first_name)
        .setIn(['account', 'zip'], action.payload.attributes.postal_code)
      ));

    case ActionTypes.LOCATE_CUSTOMER:
      return setState(state, state.withMutations(map => map
        .setIn(['loading', 'location'], false)
        .set('location', Immutable.fromJS({
          coords: {
            longitude: action.payload.coords ? action.payload.coords.longitude : defaultCoords[0],
            latitude: action.payload.coords ? action.payload.coords.latitude : defaultCoords[1]
          },
          place_name: action.payload.place_name
        }))
        .setIn(['errors', 'location'], action.payload.error ? true : false)
      ));

    case ActionTypes.RESET_CUSTOMER:
      return state = customerState.set('location', state.get('location'));

    case ActionTypes.SET_BUSINESS_LOCATION:
      return setState(state, state.withMutations(map => map
        .set('location', Immutable.fromJS({
          coords: {
            longitude: action.payload.coords ? action.payload.coords.longitude : defaultCoords[0],
            latitude: action.payload.coords ? action.payload.coords.latitude : defaultCoords[1]
          },
          place_name: action.payload.place_name
        }))
      ));

    case ActionTypes.UPDATE_CUSTOMER_VENDOR:
      return setState(state, state.setIn(['account', 'activeVendorId'], action.payload));

    case ActionTypes.TOGGLE_USER_MENU:
      return setState(state, state.setIn(['toggle', 'menu'], !state.getIn(['toggle', 'menu'])));

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/customer.js